/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'pause-sim': {
    width: 52,
    height: 52,
    viewBox: '0 0 52 52',
    data: '<path pid="0" d="M34.406 33.915a1.834 1.834 0 01-1.834 1.835H29.74a1.835 1.835 0 01-1.834-1.835V18.084c0-1.013.822-1.834 1.834-1.834h2.832c1.013 0 1.834.821 1.834 1.834v15.831zm-10.311 0a1.834 1.834 0 01-1.834 1.835H19.43a1.834 1.834 0 01-1.835-1.835V18.084c0-1.013.821-1.834 1.835-1.834h2.831c1.012 0 1.834.821 1.834 1.834v15.831zM26 0C11.64 0 0 11.637 0 26c0 14.358 11.641 26 26 26 14.36 0 26-11.642 26-26C52 11.637 40.36 0 26 0z" _fill="#DDE4E6" fill-rule="evenodd"/>'
  }
})
